import * as React from 'react';
import { useApplicationContext } from '../../../ApplicationContext';
import { QuestionFooterWrapper } from '../../../../components/QuestionFooterWrapper';
import { ButtonCloseContainer } from '../../../ButtonCloseContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export var MessageSentFooterContainer = function MessageSentFooterContainer() {
  var _useApplicationContex = useApplicationContext(),
    layoutConfiguration = _useApplicationContex.layoutConfiguration;
  return /*#__PURE__*/_jsx(QuestionFooterWrapper, {
    layoutType: layoutConfiguration.type,
    align: "center",
    children: /*#__PURE__*/_jsx(ButtonCloseContainer, {
      theme: "fill_primary",
      saveEnabled: false,
      text: "\u041E\u043A, \u043F\u043E\u043D\u044F\u0442\u043D\u043E"
    })
  });
};